import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllContactAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllContactAccounts, resetSelectedAccounts, selectAccount, selectContact, setAccountResultsLoaded, setImportType, setPortfolioImportType, toggleSelectAllContactAccounts, } from './import-holdings.actions';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const selectedContact = createReducer(null, on(selectContact, (state, { selectedContact: newContact }) => {
    return newContact;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllContactAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.id, importAsSingleHolding: false };
    });
}), on(resetSelectedAccounts, () => {
    return [];
}));
export const selectAllContactAccounts = createReducer(false, on(toggleSelectAllContactAccounts, (state) => {
    return !state;
}), on(resetSelectAllContactAccounts, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const redtailImportHoldings = combineReducers({
    currentWizardStepIndex,
    selectedContact,
    selectedAccounts,
    selectAllContactAccounts,
    portfolioImportType,
    accountResultsLoaded,
});
